import { useState } from "react";
import { Link } from "react-router-dom";
import { fmtDate, inr, tokens } from "@/lib/api";
import { EmailLookup } from "@/components/site/EmailLookup";
import { StatusBadge } from "@/components/site/Notices";

export default function MyOrders() {
  const [orders, setOrders] = useState(null);
  const onResult = (d) => {
    d.orders.forEach((o) => tokens.set("order", o.id, o.access_token));
    setOrders(d.orders);
  };
  return (
    <div className="container-x py-16">
      <h1 className="text-4xl font-extrabold tracking-tight">My Orders</h1>
      <p className="mb-8 mt-3 text-slate-600">Verify your email to view orders, receipts and delivery status.</p>
      <EmailLookup endpoint="/my/orders" onResult={onResult} testid="my-orders" />
      {orders && (
        <div className="mt-8 space-y-3" data-testid="my-orders-list">
          {orders.length === 0 && <p className="text-sm text-slate-500">No orders found for this email.</p>}
          {orders.map((o) => (
            <Link key={o.id} to={`/order/${o.id}`} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-5 hover:shadow-md" data-testid={`my-order-${o.order_number}`}>
              <div><p className="font-mono-num font-bold">{o.order_number}</p><p className="text-xs text-slate-500">{fmtDate(o.created_at, true)} · {o.item_count} item(s)</p></div>
              <div className="flex items-center gap-3"><span className="font-mono-num font-semibold">{inr(o.total)}</span><StatusBadge status={o.status} /></div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
